module.exports = __webpack_public_path__ + "static/the-book-of-laughter-and-forgetting-a18763d25c7ce12e8f460ba5575becc3.jpg";